export const RESET_ECHARTSLINE = 'reset_echartsline'


export const RESET_ROLE = 'reset_role'

export const RESET_ROLEIDLIST = 'reset_roleidlist'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js